import React from "react";
import { View } from "react-native";
import { useI18n } from "../hooks/i18n-hooks";
import Loading from "../components/Loading";
import ScreenCardHeadband from "../screens/ScreenCardHeadband";

type LoadingBoundaryProps = {
    error?: Error | string | null;
    loading?: boolean;
    clearError?: () => void | Promise<void>;
    loadingFallback?: React.ReactNode;
    children: React.ReactNode;
};

const LoadingBoundary: React.FC<LoadingBoundaryProps> = ({
    loading = false,
    loadingFallback,
    error,
    children,
}) => {
    const i18n = useI18n();
    if (loading) {
        return (
            <View style={{ alignSelf: "stretch", flex: 1 }}>
                {loadingFallback ? loadingFallback : <Loading />}
            </View>
        );
    }
    if (error) {
        let errorMessage;
        if (error instanceof Error) {
            errorMessage = i18n.t(`errors.${error.message}`);
        } else {
            errorMessage = error.toString();
        }
        if (!errorMessage) {
            errorMessage = i18n.t("errors.unknown_error");
        }
        return (
            <View style={{ alignSelf: "stretch", flex: 1, flexDirection: "column" }}>
                <ScreenCardHeadband text={errorMessage} mode="error" />
            </View>
        );
    }
    return children as React.ReactElement;
};

export default LoadingBoundary;
